// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1fkyN","insightsList":"newBusinessInsightsMenu_insightsList__3JHjN","active":"newBusinessInsightsMenu_active__11c6s"};